export default __webpack_public_path__ + "static/media/Barrier of Clouded Frost.f4e37f78.jpg";